import React, { createContext, useContext, useEffect, useState } from "react";
import { Avatar, List, notification } from "antd";

const CartContext = createContext();

export const useCartContext = () => useContext(CartContext);

const CartProvider = ({ children }) => {
  const [cartValue, setCartValue] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [api, contextHolder] = notification.useNotification();

  // Selected product details
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [selectedImages, setSelectedImages] = useState(null);

  // ============ Add to Cart ============
  const handleAddCart = (value) => {
    const newProduct = {
      productName: value.productName,
      product_price: value.product_price,
      productThickness: value.productThickness,
      productSize: value.productSize,
      productQuantity: value.productQuantity,
      productImage: value.productImage,
      productCategory:value.productCategory,
      productSubCategory:value.productSubCategory,
      productBrand:value.productBrand,
      productHsn:value.productHsn,
      productId:value.productId,
      productCategoryId:value.productCategoryId,
      productSubcategoryId:value.productSubcategoryId,
      productBrandId:value.productBrandId,
    };
  
    const index = cartValue.findIndex(
      (item) =>
        item.productName === newProduct.productName &&
        item.productThickness === newProduct.productThickness
    );
  
    if (index >= 0) {
      const updatedCart = [...cartValue];
      const updatedItem = updatedCart[index];
      updatedItem.productQuantity =
        parseInt(updatedItem.productQuantity) + parseInt(newProduct.productQuantity);
      updatedCart[index] = updatedItem;
  
      setCartValue(updatedCart);
      addtoLocatStorage(updatedCart);
      openNotification(updatedItem, `Item Quantity Increased to ${updatedItem.productQuantity}`);
    } else {
      const newCart = [...cartValue, newProduct];
      setCartValue(newCart);
      addtoLocatStorage(newCart);
      setCartCount(cartCount + 1);
      openNotification(newProduct, "Added into cart");
    }
  };
  

  // ============ Notification =============
  const openNotification = (item, message) => {
    const key = `open${Date.now()}`;
    const thicknessText = item.productThickness ? ` | Thickness: ${item.productThickness}` : '';
  
    const listDesign = (
      <List itemLayout="horizontal">
        <List.Item>
          <List.Item.Meta
            avatar={<Avatar src={item.productImage} />}
            title={item.productBrand}
            description={`Price: ₹${item.product_price} | Qty: ${item.productQuantity}${thicknessText}`}
          />
        </List.Item>
      </List>
    );
  
    api.open({
      message,
      description: listDesign,
      key,
      duration: 2,
    });
  };
  

  // ============ Add to Local Storage ============
  const addtoLocatStorage = (data) => {
    localStorage.setItem("cart", JSON.stringify(data));
  };

  // ============ Load cart from localStorage on mount ============
  useEffect(() => {
    const cartdata = JSON.parse(localStorage.getItem("cart"));
    if (cartdata && cartdata.length > 0) {
      setCartValue(cartdata);
      setCartCount(cartdata.length);
    }
  }, []);

  const contextValue = {
    handleAddCart,
    cartCount,
    cartValue,
    selectedProduct,
    setSelectedProduct,
    selectedSize,
    setSelectedSize,
    selectedPrice,
    setSelectedPrice,
    selectedImages,
    setSelectedImages,
    setCartValue,
    setCartCount,
  };

  return (
    <CartContext.Provider value={contextValue}>
      {contextHolder}
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
